import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-45f9d6d3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-display" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Welcome", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-bubble" }, "You", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-bubble" }, "Answer AI", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "skeleton",
  "aria-busy": "true",
  "aria-live": "polite"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "skeleton-paragraph",
    role: "status",
    "aria-label": "Loading content..."
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "skeleton-paragraph",
    role: "status",
    "aria-label": "Loading content..."
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "skeleton-paragraph",
    role: "status",
    "aria-label": "Loading content..."
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "skeleton-paragraph",
    role: "status",
    "aria-label": "Loading content..."
  })
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "answer"
}
const _hoisted_10 = {
  key: 0,
  class: "answer"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ai-warning" }, " AI-generated content may contain mistakes. ", -1))
const _hoisted_17 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InitialChatSuggestions = _resolveComponent("InitialChatSuggestions")!
  const _component_Sources = _resolveComponent("Sources")!
  const _component_Feedback = _resolveComponent("Feedback")!
  const _component_SuggestedFollowOnQuestions = _resolveComponent("SuggestedFollowOnQuestions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.answerLoading && _ctx.conversations.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InitialChatSuggestions)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversations, (conversation, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "chat-item",
        key: index
      }, [
        _hoisted_4,
        _createElementVNode("p", {
          class: "question",
          ref_for: true,
          ref: "questions"
        }, _toDisplayString(conversation.question), 513),
        _hoisted_5,
        (_ctx.answerLoading && index === _ctx.conversations.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (conversation.outcome !== 'success')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (conversation.outcome === 'content_filter')
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, " Sorry, I am not able to respond to that question. "))
                      : (conversation.outcome === 'Rate limit exceeded')
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Sorry, I am not able to respond right now. Please try again. "))
                        : (_openBlock(), _createElementBlock("p", _hoisted_13, " Sorry, I am not able to respond to that question. Please try again. "))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", {
                      innerHTML: 
              _ctx.renderAnswer(
                conversation.answer ?? '',
                conversation.sources ?? []
              )
            
                    }, null, 8, _hoisted_15),
                    _hoisted_16,
                    _createVNode(_component_Sources, {
                      sources: conversation.sources
                    }, null, 8, ["sources"]),
                    _createVNode(_component_Feedback, {
                      sessionId: _ctx.sessionId,
                      interactionId: conversation.interaction_id
                    }, null, 8, ["sessionId", "interactionId"]),
                    (_ctx.view !== 'uat' && index === _ctx.conversations.length - 1)
                      ? (_openBlock(), _createBlock(_component_SuggestedFollowOnQuestions, {
                          key: 0,
                          followOnQuestions: conversation.suggestedFollowOnQuestions,
                          suggestionsLoading: _ctx.suggestionsLoading
                        }, null, 8, ["followOnQuestions", "suggestionsLoading"]))
                      : _createCommentVNode("", true)
                  ]))
            ]))
      ]))
    }), 128)),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ]))
}